import React, { use } from 'react'
import AdminLayout from '../../../layouts/AdminLayout'
import { Navigate, useNavigate } from 'react-router-dom'
import { adminPaths } from '../../../routes/admin'
const Messaging = () => {
    const navigate = useNavigate();
  return (
    <div>
         <AdminLayout>
             <div className="ct_px_40 my-5">
                        <div className="container-fluid">
                            <div className="row gx-5">
                                  <div className="col-lg-2 col-md-3 mb-4 mb-md-0">
                      <h4 className="mb-0 ct_fs_20 mb-4">Messaging</h4>
                      <div className="ct_filter_btn">
                        <button
                          className="ct_outline_grey ct_yellow_btn ct_h_35 d-flex align-items-center gap-2"
                         
                        >
                          Filter <img src="/assets/img/octicon_filter-16.png" alt="" />
                        </button>
                      </div>
                      <div
                        className="ct_filter_sidebar ct_custom_scroll p-0 "
                      >
                        <div
                          className="ct_close_filter d-block d-lg-none"
                        
                        >
                          <i className="fa-solid fa-xmark"></i>
                        </div>
                        <div className="mt-4">
                          <h5 className="ct_fs_16 mb-3">Roles</h5>
                          <ul>
                            <li>
                              <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value=""
                                  id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                  All Roles
                                </label>
                              </div>
                            </li>
                            <li className="mt-2">
                              <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value=""
                                  id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                  Founder  
                                </label>
                              </div>
                            </li>
                            <li className="mt-2">
                              <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value=""
                                  id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                Freelancer
                                </label>
                              </div>
                            </li>
                            <li className="mt-2">
                              <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value=""
                                  id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                  Coach
                                </label>
                              </div>
                            </li>
                            <li className="mt-2">
                              <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value=""
                                  id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                  Enterprise
                                </label>
                              </div>
                            </li>
                            <li className="mt-2">
                              <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value=""
                                  id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                  System/ Admin
                                </label>
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div className="mt-4">
                          <h5 className="ct_fs_16 mb-3">Date Range</h5>
                          <ul>
                            <li>
                              <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value=""
                                  id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                  Today
                                </label>
                              </div>
                            </li>
                            <li className="mt-2">
                              <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value=""
                                  id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                  Last 7 Days
                                </label>
                              </div>
                            </li>
                            <li className="mt-2">
                              <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value=""
                                  id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                               This Month
                                </label>
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div className="mt-4">
                          <h5 className="ct_fs_16 mb-3">Status</h5>
                          <ul>
                            <li>
                              <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value=""
                                  id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                  All
                                </label>
                              </div>
                            </li>
                            <li className="mt-2">
                              <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value=""
                                  id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                  Unread
                                </label>
                              </div>
                            </li>
                            <li className="mt-2">
                              <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value=""
                                  id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                  Open
                                </label>
                              </div>
                            </li>
                            <li className="mt-2">
                              <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value=""
                                  id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                  Resolved
                                </label>
                              </div>
                            </li>
                            <li className="mt-2">
                              <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value=""
                                  id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                  Archived
                                </label>
                              </div>
                            </li>
                          </ul>
                        </div>
                      
                      </div>
                    </div>
                                <div className='col-lg-10 col-md-9 mb-4 mb-md-0'>
                                      <div className="d-flex align-items-center gap-3 justify-content-between mb-4 ct_flex_col_1199">
                      <div>
                        <h4 className="mb-0 ct_fs_20  mb-0">User Inquiries</h4>
                        <p className="mb-0 ct_text_clr_757886">
                         View and respond to questions, requests, or concerns submitted by users across the platform
                        </p>
                      </div>
                      <div className="d-flex align-items-center gap-3 ct_flex_col_575 ct_w_100_575">
                        <div className="position-relative ct_w_100_575">
                          <input
                            type="text"
                            className="form-control ct_input ct_h_40 ps-5 ct_border_radius_20"
                            placeholder="Search by Title"
                          />
                          <i className="fa-solid fa-search ct_input_icon_left"></i>
                        </div>
                        <button className='ct_yellow_btn ct_h_40 ct_white_nowrap ct_w_100_575'><i class="fa-solid fa-plus me-1 ct_fs_14"></i> Create Announcement</button>
                     
                      </div>
                    </div>


                    <div class="d-flex align-items-center gap-3 justify-content-between mb-3 ct_flex_col_575 ct_pb_3_575" style={{borderBottom: "1px solid rgb(204, 204, 204)"}}>
   <ul class="ct_table_filter border-0">
      <li class="active">User Inquires (50)  </li>
      <li>Flagged Conversations (30)</li>
      <li>Sent Announcements (50)</li>
      <li>Project (50)</li>
   </ul>
 
</div>
        
        
                     <div class="table-responsive ct_custom_table ct_custom_table2 pt-2">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Role</th>
                          <th>Email</th>
                          <th>Subject</th>
                          <th>Date Sent</th>
                          <th>Status</th>
                        <th></th>
                        
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                           <h5 class="ct_fs_16  mb-0">Alex Brown</h5>
                          </td>
                          <td>Founder</td>
                          <td>alexbrown@gmail.com</td>
                          <td><span className='ct_overlay_text'>“I need help with my project”</span></td>
                          <td>Jun 29,2025</td>
                          <td>
                            {/* <span class="ct_publish_badge">Under review</span> */}
                            <select className='form-control ct_input ct_publish_badge ct_h_35' style={{appearance:"auto"}}>
                              <option>Open</option>

                            </select>
                          </td>
                         
                          <td>
                            <div class="ct_right_dropdown dropdown">
                              <button
                                id="dropdownMenuButton"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <i class="fa-solid fa-ellipsis"></i>
                              </button>
                              <ul
                                class="dropdown-menu"
                                aria-labelledby="dropdownMenuButton1"
                              >
                                <li>
                                  <a
                                    class="dropdown-item"
                                    onClick={()=>navigate(adminPaths?.ReportDetails)}
                                   
                                    >View Messsage</a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item ct_darksky_blue_text"
                                  
                                    href="javascript:void(0)"
                                    >Reply to Sender</a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item ct_yellow_text"
                                    href="javascript:void(0)"
                                  
                                    >Mark as Resolved
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item ct_orange_text"
                                    href="javascript:void(0)"
                                    data-bs-target="#ct_suspend_account"
                                    data-bs-toggle="modal"
                                    >Archive
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item text-danger"
                                    href="javascript:void(0)"
                                   
                                    >Delete 
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </td>
                          
                          
                        </tr>
                         <tr>
                          <td>
                           <h5 class="ct_fs_16  mb-0">Alex Brown</h5>
                          </td>
                          <td>Founder</td>
                          <td>alexbrown@gmail.com</td>
                          <td><span className='ct_overlay_text'>“I need help with my project”</span></td>
                           <td>Jun 29,2025</td>
                          <td>
                            {/* <span class="ct_suspended">Unread</span> */}
                            <select class="form-control ct_input ct_h_35 ct_suspended" style={{appearance:"auto"}}>
                              <option>Unread</option>

                            </select>
                          </td>
                         
                          <td>
                            <div class="ct_right_dropdown dropdown">
                              <button
                                id="dropdownMenuButton"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <i class="fa-solid fa-ellipsis"></i>
                              </button>
                              <ul
                                class="dropdown-menu"
                                aria-labelledby="dropdownMenuButton1"
                              >
                                <li>
                                  <a
                                    class="dropdown-item"
                                    onClick={()=>navigate(adminPaths?.ReportDetails)}
                                   
                                    >View Messsage</a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item ct_darksky_blue_text"
                                  
                                    href="javascript:void(0)"
                                    >Reply to Sender</a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item ct_yellow_text"
                                    href="javascript:void(0)"
                                  
                                    >Mark as Resolved
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item ct_orange_text"
                                    href="javascript:void(0)"
                                    data-bs-target="#ct_suspend_account"
                                    data-bs-toggle="modal"
                                    >Archive
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item text-danger"
                                    href="javascript:void(0)"
                                   
                                    >Delete 
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </td>
                          
                          
                        </tr>
                         <tr>
                          <td>
                           <h5 class="ct_fs_16  mb-0">Alex Brown</h5>
                          </td>
                          <td>Founder</td>
                          <td>alexbrown@gmail.com</td>
                          <td><span className='ct_overlay_text'>“I need help with my project”</span></td>
                           <td>Jun 29,2025</td>
                          <td>
                              <select class="form-control ct_input ct_h_35 ct_draft_badge" style={{appearance:"auto"}}>
                              <option>Resolved</option>

                            </select>
                          </td>
                         
                          <td>
                            <div class="ct_right_dropdown dropdown">
                              <button
                                id="dropdownMenuButton"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <i class="fa-solid fa-ellipsis"></i>
                              </button>
                              <ul
                                class="dropdown-menu"
                                aria-labelledby="dropdownMenuButton1"
                              >
                                <li>
                                  <a
                                    class="dropdown-item"
                                    onClick={()=>navigate(adminPaths?.ReportDetails)}
                                   
                                    >View Messsage</a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item ct_darksky_blue_text"
                                  
                                    href="javascript:void(0)"
                                    >Reply to Sender</a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item ct_yellow_text"
                                    href="javascript:void(0)"
                                  
                                    >Mark as Resolved
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item ct_orange_text"
                                    href="javascript:void(0)"
                                    data-bs-target="#ct_suspend_account"
                                    data-bs-toggle="modal"
                                    >Archive
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item text-danger"
                                    href="javascript:void(0)"
                                   
                                    >Delete 
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </td>
                          
                          
                        </tr>
                         <tr>
                          <td>
                           <h5 class="ct_fs_16  mb-0">Alex Brown</h5>
                          </td>
                          <td>Founder</td>
                          <td>alexbrown@gmail.com</td>
                          <td><span className='ct_overlay_text'>“I need help with my project”</span></td>
                           <td>Jun 29,2025</td>
                          <td>
                            <span class="ct_suspended">Resolved</span>
                          </td>
                         
                          <td>
                            <div class="ct_right_dropdown dropdown">
                              <button
                                id="dropdownMenuButton"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <i class="fa-solid fa-ellipsis"></i>
                              </button>
                              <ul
                                class="dropdown-menu"
                                aria-labelledby="dropdownMenuButton1"
                              >
                                <li>
                                  <a
                                    class="dropdown-item"
                                    onClick={()=>navigate(adminPaths?.ReportDetails)}
                                   
                                    >View Messsage</a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item ct_darksky_blue_text"
                                  
                                    href="javascript:void(0)"
                                    >Reply to Sender</a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item ct_yellow_text"
                                    href="javascript:void(0)"
                                  
                                    >Mark as Resolved
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item ct_orange_text"
                                    href="javascript:void(0)"
                                    data-bs-target="#ct_suspend_account"
                                    data-bs-toggle="modal"
                                    >Archive
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item text-danger"
                                    href="javascript:void(0)"
                                   
                                    >Delete 
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </td>
                          
                          
                        </tr>
                         <tr>
                          <td>
                           <h5 class="ct_fs_16  mb-0">Alex Brown</h5>
                          </td>
                          <td>Founder</td>
                          <td>alexbrown@gmail.com</td>
                          <td><span className='ct_overlay_text'>“I need help with my project”</span></td>
                           <td>Jun 29,2025</td>
                          <td>
                            <span class="ct_suspended">Resolved</span>
                          </td>
                         
                          <td>
                            <div class="ct_right_dropdown dropdown">
                              <button
                                id="dropdownMenuButton"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <i class="fa-solid fa-ellipsis"></i>
                              </button>
                              <ul
                                class="dropdown-menu"
                                aria-labelledby="dropdownMenuButton1"
                              >
                                <li>
                                  <a
                                    class="dropdown-item"
                                    onClick={()=>navigate(adminPaths?.ReportDetails)}
                                   
                                    >View Messsage</a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item ct_darksky_blue_text"
                                  
                                    href="javascript:void(0)"
                                    >Reply to Sender</a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item ct_yellow_text"
                                    href="javascript:void(0)"
                                  
                                    >Mark as Resolved
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item ct_orange_text"
                                    href="javascript:void(0)"
                                    data-bs-target="#ct_suspend_account"
                                    data-bs-toggle="modal"
                                    >Archive
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item text-danger"
                                    href="javascript:void(0)"
                                   
                                    >Delete 
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </td>
                          
                          
                        </tr>
                         <tr>
                          <td>
                           <h5 class="ct_fs_16  mb-0">Alex Brown</h5>
                          </td>
                          <td>Founder</td>
                          <td>alexbrown@gmail.com</td>
                          <td><span className='ct_overlay_text'>“I need help with my project”</span></td>
                           <td>Jun 29,2025</td>
                          <td>
                            <span class="ct_suspended">Resolved</span>
                          </td>
                         
                          <td>
                            <div class="ct_right_dropdown dropdown">
                              <button
                                id="dropdownMenuButton"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <i class="fa-solid fa-ellipsis"></i>
                              </button>
                              <ul
                                class="dropdown-menu"
                                aria-labelledby="dropdownMenuButton1"
                              >
                                <li>
                                  <a
                                    class="dropdown-item"
                                    onClick={()=>navigate(adminPaths?.ReportDetails)}
                                   
                                    >View Messsage</a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item ct_darksky_blue_text"
                                  
                                    href="javascript:void(0)"
                                    >Reply to Sender</a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item ct_yellow_text"
                                    href="javascript:void(0)"
                                  
                                    >Mark as Resolved
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item ct_orange_text"
                                    href="javascript:void(0)"
                                    data-bs-target="#ct_suspend_account"
                                    data-bs-toggle="modal"
                                    >Archive
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item text-danger"
                                    href="javascript:void(0)"
                                   
                                    >Delete 
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </td>
                          
                          
                        </tr>
                    
                  
                      </tbody>
                    </table>
                  </div>
        
                                </div>
                            </div>
                        </div>
                    </div>
         </AdminLayout>
    </div>
  )
}

export default Messaging